<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="3">
                    <input type="text" v-model="searchAttribute" placeholder="Attribute" class="form-control"/>
                </CCol>
                <CCol sm="4">
                    <input type="text" v-model="searchKeterangan" placeholder="Keterangan Attribute" class="form-control"/>
                </CCol>
                <CCol sm="3">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchInterval" class="form-control" v-model="searchInterval" placeholder="Pilih Interval"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6">
                    <CButton color="primary" class="mr-1" @click="showModal()" variant='outline'>Penanggung Jawab</CButton><span class="ml-2" style="color:rgba(154, 154, 154, 1);font-size:12px"><span v-if="viewNama != ''" class="mt-1 font-weight-bold">{{viewNama}}</span><span v-if="viewJabatan != ''"> -</span> {{viewJabatan}}</span>
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <!-- <img class="mr-5 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/> -->
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="penanggungJawabModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Penanggung Jawab Gaji</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="penanggungJawabModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mb-5">
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="6">
                                    <label>
                                        Nama Pegawai
                                    </label>
                                    <div class="autocomplete">
                                        <input type="text"
                                                class="form-control"
                                                @click="toggleVisiblePegawai()"
                                                @blur="toggleCloseVisiblePegawai()"
                                                v-model="queryPegawai"
                                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                                @keydown.up="upPegawai"
                                                @keydown.down="downPegawai"
                                                @keydown.enter="selectItemPegawai"
                                                placeholder="Pilih Pegawai"
                                        >
                                        <div class="popovers" v-show="visiblePegawai">
                                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                                <ul>
                                                <li v-for="(match, index) in matchesPegawai"
                                                    :key="index"
                                                    :class="{ 'selected': (selectedPegawai == index)}"
                                                    @click="itemClickedPegawai(index)"
                                                    v-text="match['text']"></li>
                                                </ul>
                                            </div>
                                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                                Data Tidak Ditemukan
                                            </div>
                                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                                Start Typing...
                                            </div>
                                        </div>
                                    </div>
                                </CCol>
                                <CCol sm="6">
                                    <label>
                                        Jabatan
                                    </label>
                                    <input type="text" v-model="jabatan" :disabled="disJabatan==true" :style="disJabatan&&'background-color:whitesmoke;'" class="form-control" placeholder="Jabatan" />
                                </CCol>
                            </CRow>
                            <CRow class="mt-3">
                                <CCol sm="6">
                                    <label>
                                        Upload Tanda Tangan
                                    </label>
                                    <div v-if="urlImage == '' || urlImage == 'null'">
                                        <input v-on:change="loadFile" style="display:none"  id="inputFile" class="hide" type="file" accept=".jpg, .png, .bmp" />
                                        <div onclick="document.getElementById('inputFile').click()" class="cards-image">ttd</div>
                                    </div>
                                    <div v-else>
                                        <img style="position:absolute;object-fit: cover" :src="urlImage" width="60" height="80" />
                                        <button @click="removeImage()" class="btn btn-danger" style="margin-left: 80px!important" size="sm">Delete</button>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="12">
                        <CButton :disabled="loadingPenanggungJawab == true" style="float:right!important" @click="saveImage()" class="btn btn-edit-submit">
                            <span v-if="loadingPenanggungJawab == false">Ya, Simpan</span>
                            <CSpinner v-else color="default" size="sm"/>
                        </CButton>
                        <CButton @click="penanggungJawabModal = false" type="button" style="float:right" class="btn btn-cancel mr-2">Batal</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nomor Attribute</label>
                        <input 
                            disabled
                            style="background-color:whitesmoke"
                            class="form-control mr-2" 
                            v-model="dataAttribute"
                            placeholder="Nama Attribute" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nama Attribute</label>
                        <input 
                            disabled
                            style="background-color:whitesmoke"
                            v-if="dataEditable == 'T'"
                            class="form-control mr-2" 
                            v-model.trim="$v.dataKeterangan.$model"
                            :class="{ 'is-invalid':$v.dataKeterangan.$error, 'is-valid': !$v.dataKeterangan.$invalid }"
                            placeholder="Nama Attribute" 
                            type="text"
                        />
                        <input 
                            v-else
                            class="form-control mr-2" 
                            v-model.trim="$v.dataKeterangan.$model"
                            :class="{ 'is-invalid':$v.dataKeterangan.$error, 'is-valid': !$v.dataKeterangan.$invalid }"
                            placeholder="Nama Attribute" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Interval</label>
                        <model-select :options="dataInterval"
                            class="form-control model-select"
                            v-model.trim="$v.interval.$model"
                            :class="{ 'is-invalid select-invalid':$v.interval.$error, 'is-valid select-valid': !$v.interval.$invalid }"
                            placeholder="Pilih Interval">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Detail (Penghasilan/Potongan)</label>
                        <model-select :options="dataPenambah"
                            v-if="dataEditable == 'T'"
                            isDisabled
                            style="background-color:whitesmoke"
                            class="form-control model-select"
                            v-model.trim="$v.penambah.$model"
                            :class="{ 'is-invalid select-invalid':$v.penambah.$error, 'is-valid select-valid': !$v.penambah.$invalid }"
                            placeholder="Pilih Interval">
                        </model-select>
                        <model-select :options="dataPenambah"
                            v-else
                            class="form-control model-select"
                            v-model.trim="$v.penambah.$model"
                            :class="{ 'is-invalid select-invalid':$v.penambah.$error, 'is-valid select-valid': !$v.penambah.$invalid }"
                            placeholder="Pilih Interval">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Status</label>
                        <model-select :options="dataAktif"
                            class="form-control model-select"
                            v-model.trim="$v.aktif.$model"
                            :class="{ 'is-invalid select-invalid':$v.aktif.$error, 'is-valid select-valid': !$v.aktif.$invalid }"
                            placeholder="Pilih Status">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Satuan Nominal</label>
                        <model-select :options="dataSatuan"
                            :isDisabled="disSatuan"
                            :style="disSatuan&&'background-color:whitesmoke'"
                            class="form-control model-select"
                            v-model.trim="$v.satuan.$model"
                            :class="{ 'is-invalid select-invalid':$v.satuan.$error, 'is-valid select-valid': !$v.satuan.$invalid }"
                            placeholder="Pilih Satuan Nominal">
                        </model-select>
                        <span class="text-info" v-if="satuan.value == 'N'">*Nominal akan berupa rupiah</span>
                        <span class="text-info" v-if="satuan.value == 'P'">*Nominal akan berupa persentase terhadap gaji pokok</span>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableGaji'
import { DataApi, DataApiUpload } from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    components: {
        ModelSelect,
        Tables
    },
    mixins: [validationMixin],
    validations: {
        dataKeterangan: {
            required,
        },
        interval: {
            value: {
                required
            },
            text: {
                required
            }
        },
        aktif: {
            value: {
                required
            },
            text: {
                required
            }
        },
        penambah: {
            value: {
                required
            },
            text: {
                required
            }
        },
        satuan: {
            value: {
                required
            },
            text: {
                required
            }
        },
    },
    data() {
        return {
            success: true,
            penanggungJawabModal: false,
            loadingPenanggungJawab: false,
            viewJabatan: '',
            viewNama: '',
            viewTTD: '',
            viewPenanggungJawab: '',
            disJabatan: false,
            showImage: '',
            urlImage: '',
            urlPath: '',

            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',
            jabatan: '',

            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            dataTh: ['Attribute', 'Keterangan', 'Inverval', 'Detail', 'Status', 'Action'],
            dataTd: ['attribute', 'keterangan', 'interval', 'penambah', 'aktif', 'action'],
            styleTable: ['75px', '125px', '50px', '125px', '50px', '50px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            currentAlertCounter: 0,

            // data model

            tipe: 'U',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchAttribute: '',
            searchKeterangan: '',
            dataSearchInterval: [],
            searchInterval: {
                value: '',
                text: ''
            },

            // data
            dataUnix: '',
            dataKeterangan: '',
            dataInterval: [],
            interval: {
                value: '',
                text: ''
            },
            dataAktif: [],
            aktif: {
                value: '',
                text: ''
            },
            dataAttribute: '',
            dataPenambah: [],
            penambah: {
                value: '',
                text: ''
            },
            dataEditable: '',
            dataSatuan: [],
            satuan: {
                value: '',
                text: ''
            },
            organisasi: '',
            lvl: '',


            // error
            errorMessage: '',
            disSatuan: false,
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchAttribute() {
            this.flagSearch = true
        },
        searchKeterangan() {
            this.flagSearch = true
        },
        searchInterval() {
            this.flagSearch = true
        },
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawai = ''
                this.jabatan = ''
            }
            this.getDataPegawai('null')
        },
        jabatan() {
            if(this.jabatan == '') {
                this.disJabatan = false
            } else {
                this.disJabatan = true
            }
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: this.queryPegawai,
                    pageIn: 1,
                    pegawaiId: '',
                    tipePegawai: ''
                }
            } else {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: '',
                    pageIn: 1,
                    pegawaiId: val,
                    tipePegawai: ''
                }
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik,
                        jabatan: tempData[i].jabatan
                    }
                    this.dataPegawai.push(onPush)
                }
                if(val != 'null') {
                    this.queryPegawai = this.dataPegawai[0].text
                    this.idPegawai = this.dataPegawai[0].value
                    this.jabatan = this.dataPegawai[0].jabatan
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawai = this.selectedItemPegawai.value
            this.jabatan = this.selectedItemPegawai.jabatan
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.alamat.toLowerCase() < b.alamat.toLowerCase()) {
                        return -1
                    }
                    if (a.alamat.toLowerCase() > b.alamat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.kota.toLowerCase() < b.kota.toLowerCase()) {
                        return -1
                    }
                    if (a.kota.toLowerCase() > b.kota.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.provinsi.toLowerCase() < b.provinsi.toLowerCase()) {
                        return -1
                    }
                    if (a.provinsi.toLowerCase() > b.provinsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.radius.toLowerCase() < b.radius.toLowerCase()) {
                        return -1
                    }
                    if (a.radius.toLowerCase() > b.radius.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDataSearchInterval() {
            this.dataSearchInterval = [
                { value: '', text: 'Semua' },
                { value: 'B', text: 'Bulan' },
                { value: 'H', text: 'Hari'}
            ]
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                attribute: this.searchAttribute,
                keterangan: this.searchKeterangan,
                limit: this.size,
                pageIn: this.page,
                interval: this.searchInterval.value
            }
            DataApi.post("salary/attribute/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data

                    this.viewJabatan = response.data.jabatan
                    this.viewNama = response.data.namaPenanggungJawab
                    this.viewPenanggungJawab = response.data.penanggungJawab
                    this.urlImage = response.data.ttd

                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchKeterangan = ''
            this.searchInterval.value = ''
            this.searchInterval.text = ''
            this.searchAttribute = ''
            this.getDataSearchInterval()
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.tipe = 'U'
                this.getDataInterval()
                this.getDataAktif()
                this.getDataPenambah()
                this.getDataSatuan()
                this.$v.$reset()
            }
        },
        goSave() {
            let payload = {
                aktif: this.aktif.value,
                attribute: this.dataAttribute,
                interval: this.interval.value,
                keterangan: this.dataKeterangan,
                penambah: this.penambah.value,
                satuan: this.satuan.value,
                tipe: this.tipe,
                unix: this.dataUnix
            }
            DataApi.post("salary/attribute/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.dataUnix = generate.unix
            this.dataKeterangan = generate.keterangan
            this.dataAttribute = generate.attribute
            if(this.dataAttribute == '0' || this.dataAttribute == 0) {
                this.satuan.value = 'N'
                this.satuan.text = 'Satuan Desimal'
                this.disSatuan = true
            } else {
                this.disSatuan = false
                this.satuan.value = ''
                this.satuan.text = ''
                this.getDataSatuan()
            }
            this.dataEditable = generate.edit
            var i,j,k,l = 0
            let dataAktif = this.dataAktif
            let dataPenambah = this.dataPenambah
            let dataInterval = this.dataInterval
            let dataSatuan = this.dataSatuan
            let aktif = generate.aktif
            let penambah = generate.penambah
            let interval = generate.interval
            let satuan = generate.satuan
            for(i=0;i<dataAktif.length;i++) {
                if(aktif == dataAktif[i].value) {
                    this.aktif.value = dataAktif[i].value
                    this.aktif.text = dataAktif[i].text
                }
            }
            for(j=0;j<dataPenambah.length;j++) {
                if(penambah == dataPenambah[j].value) {
                    this.penambah.value = dataPenambah[j].value
                    this.penambah.text = dataPenambah[j].text
                }
            }
            for(k=0;k<dataInterval.length;k++) {
                if(interval == dataInterval[k].value) {
                    this.interval.value = dataInterval[k].value
                    this.interval.text = dataInterval[k].text
                }
            }
            for(l=0;l<dataSatuan.length;l++) {
                if(satuan == dataSatuan[l].value) {
                    this.satuan.value = dataSatuan[l].value
                    this.satuan.text = dataSatuan[l].text
                }
            }
            this.tipe = 'U'
            this.moving()
        },
        getDataInterval() {
            this.dataInterval = [
                { value: 'B', text: 'Bulan' },
                { value: 'H', text: 'Hari'}
            ]
        },
        getDataAktif() {
            this.dataAktif = [
                { value: 'Y', text: 'Aktif' },
                { value: 'T', text: 'Tidak Aktif'}
            ]
        },
        getDataPenambah() {
            this.dataPenambah = [
                { value: 'A', text: 'Penghasilan Tetap' },
                { value: 'B', text: 'Penghasilan Tidak Tetap'},
                { value: 'C', text: 'Potongan Ditanggung Perusahaan'},
                { value: 'D', text: 'Potongan Ditanggung Pegawai'}
            ]
        },
        getDataSatuan() {
            this.dataSatuan = [
                { value: 'N', text: 'Satuan Desimal' },
                { value: 'P', text: 'Satuan Persen'}
            ]
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },


        loadFile(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.showImage = files[0];
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            this.loadingPenanggungJawab = true
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.goPenanggungJawab()
                    } else {
                        alert('Upload Photo Failed !')
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.goPenanggungJawab()
            } else {
                this.urlPath = this.urlImage
                this.goPenanggungJawab()
            }
        },
        goPenanggungJawab() {
            let payload = {
                idPegawai: this.idPegawai,
                jabatan: this.jabatan,
                ttd: this.urlPath
            }
            DataApi.post("/salary/penanggungjawab/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.loadingPenanggungJawab = false
                this.currentAlertCounter = 7
                this.penanggungJawabModal = false
                this.urlPath = ''
                this.urlImage = ''
                this.showImage = ''
                this.dataPegawai = []
                this.jabatan = ''
                this.idPegawai = ''
                this.queryPegawai = ''
            })
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },
        showModal() {
            this.penanggungJawabModal = true
            if(this.viewPenanggungJawab != '') {
                this.getDataPegawai(this.viewPenanggungJawab)
            }
        },
        getDataToken() {
            this.$store.state.loadingScreen = true
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.lvl = res.data.lvl
                    this.organisasi = res.data.organisasi
                }
                this.$store.state.loadingScreen = false
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataToken()
        this.getDataSearchInterval()
        this.getDataInterval()
        this.getDataAktif()
        this.getDataPenambah()
        this.getDataSatuan()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    cursor: pointer;
    text-align: center;
    font-size: 12px;
    color: rgba(96, 96, 96, 1);
    line-height: 70px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 60px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 80px !important;
}
.invalid-feedback {
    margin-top: -16px;
    float: right;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.modal-button-simpan {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.modal-button-simpan:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: rgba(48, 107, 240, 1);
    color: white;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
</style>
